import React, { FC } from 'react';

import Avatar from 'common/components/base/avatar';
import { CONCURRENT_UPLOAD_TITLE, UPLOADED_ON_TITLE } from 'common/config';

import './ConcurrentUploadModal.scss';

type ConcurrentUploadModalProps = {
    userName: string;
    activeSection: string;
    uploadedOn: string;
};

const ConcurrentUploadModal: FC<ConcurrentUploadModalProps> = ({
    userName,
    activeSection,
    uploadedOn
}: ConcurrentUploadModalProps) => {
    return (
        <div className="concurrent-upload-container">
            <div className="concurrent-upload-title">{CONCURRENT_UPLOAD_TITLE}</div>
            <div className="concurrent-upload-details">
                <div className="user-section">
                    <div className="user-avatar">
                        <Avatar userName={userName} size="large" />
                    </div>
                    <div className="user-details">
                        <div className="user-name">{userName}</div>
                        <div className="user-active-section">{`(${activeSection})`}</div>
                    </div>
                </div>
                <div className="uploaded-time-section">
                    <div className="uploaded-time-title">{UPLOADED_ON_TITLE}</div>
                    <div className="uploaded-time-value">{uploadedOn}</div>
                </div>
            </div>
        </div>
    );
};

export default ConcurrentUploadModal;
